import {
  headingMixins,
  paragraphMixins
} from "./chunk-6FXAQBW6.mjs";
import {
  React,
  __name,
  init_react_import
} from "./chunk-65BGW52G.mjs";

// components/Card/Header/Header.tsx
init_react_import();
import { Spacing } from "@persona-id/design-tokens";
import styled, { css } from "styled-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
__name(_extends, "_extends");
var HeaderContainer = styled.div`
  ${paragraphMixins.md};
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:only-child) {
    margin: 0px 0px ${Spacing[4]} 0px;
  }
  ${({ variant }) => variant === "section" && css`
      border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
    `}
`;
var TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing[2]};
`;
var Title = styled.h3`
  display: flex;
  align-items: center;
  margin: 0px;
  gap: ${Spacing[2]};
  ${({ variant }) => {
  switch (variant) {
    case "section":
      return paragraphMixins.lgBold;
    case "title":
    default:
      return headingMixins.sm;
  }
}}
`;
var ActionsContainer = styled.div`
  color: ${({ theme }) => theme.color.text.secondary};
  display: flex;
  align-items: center;
  gap: ${Spacing[2]};
`;
var Header = /* @__PURE__ */ __name(({ children, variant, actions, subtitle, ...elemProps }) => {
  return /* @__PURE__ */ React.createElement(HeaderContainer, _extends({
    variant
  }, elemProps), /* @__PURE__ */ React.createElement(TitleContainer, null, /* @__PURE__ */ React.createElement(Title, {
    variant
  }, children), subtitle), /* @__PURE__ */ React.createElement(ActionsContainer, null, actions));
}, "Header");
var Root = Header;
var Header_default = Header;

export {
  HeaderContainer,
  TitleContainer,
  Title,
  ActionsContainer,
  Root,
  Header_default
};
//# sourceMappingURL=chunk-SMLT6GZW.mjs.map